var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, action, observable } from 'mobx';
var SigningStore = /** @class */ (function () {
    function SigningStore() {
        Object.defineProperty(this, "_callback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "isSigningDialogVisible", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        makeObservable(this);
        window.$SigningStore = this;
    }
    Object.defineProperty(SigningStore.prototype, "showSigningDialog", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (callback) {
            this._callback = callback;
            this.isSigningDialogVisible = true;
        }
    });
    Object.defineProperty(SigningStore.prototype, "closeSigningDialog", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isOK, signatureText) {
            this.isSigningDialogVisible = false;
            if (this._callback)
                this._callback(isOK, signatureText);
        }
    });
    Object.defineProperty(SigningStore.prototype, "stringifySignatures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (signatures) {
            return JSON.stringify(Array.isArray(signatures) ? signatures : []);
        }
    });
    Object.defineProperty(SigningStore.prototype, "parseSignatures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (signatureText) {
            if (!signatureText)
                return [];
            if (!signatureText.startsWith('[') || !signatureText.endsWith(']'))
                return [];
            return JSON.parse(signatureText);
        }
    });
    __decorate([
        observable
    ], SigningStore.prototype, "isSigningDialogVisible", void 0);
    __decorate([
        action
    ], SigningStore.prototype, "showSigningDialog", null);
    __decorate([
        action
    ], SigningStore.prototype, "closeSigningDialog", null);
    return SigningStore;
}());
export default SigningStore;
